const imageData2=[
    {
        url:"https://res.cloudinary.com/bazeercloud/image/upload/v1710746585/images/marblebowl_whgksp.webp",
        description:"A stunning piece of art featuring a peacock design intricately carved into high-quality marble. Symbolizing purity and grace, this sankh is a beautiful addition to any decor, adding elegance and cultural significance to your space"
      
        
       
    },
    {
        url:"https://res.cloudinary.com/bazeercloud/image/upload/v1710746572/images/sankh2_njxbbx.jpg",
    
         description:"This beautifully crafted marble sankh is designed for performing sacred rituals and bathing ceremonies Pooja Snan of deities. Made from high-quality marble, this sankh is a symbol of purity and spirituality, enhancing the sanctity of your worship space. Its intricate craftsmanship and smooth finish make it a perfect choice for devotees seeking a divine connection during their worship rituals."
    },
    {
        url:"https://res.cloudinary.com/bazeercloud/image/upload/v1710746578/images/bowl3_hfbp10.webp",
        description:" Crafted with care, this marble sankh is ideal for sacred rituals and ceremonial baths (Pooja Snan) of deities. Its elegant design and smooth texture elevate the spiritual ambiance of your worship area, symbolizing purity and devotion in every ritual."
       
    },
    

];

export default imageData2;